import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#6B6B6B",
      d: "m15.962 13.466-1.175 1.175-3.29 3.29a3.31 3.31 0 0 1-4.676 0 3.31 3.31 0 0 1 0-4.675l1.88-1.881 5.604-5.604a2.264 2.264 0 0 1 3.198 0 2.264 2.264 0 0 1 0 3.198l-3.606 3.605-1.422 1.421-1.853 1.854a1.186 1.186 0 0 1-1.675 0 1.187 1.187 0 0 1 0-1.676l2.686-2.687.588-.588 2.511-2.51-.783-.784-3.099 3.1-2.686 2.687a2.295 2.295 0 0 0 0 3.24 2.295 2.295 0 0 0 3.24 0l1.69-1.69 1.585-1.584 3.606-3.606a3.371 3.371 0 0 0 0-4.762 3.371 3.371 0 0 0-4.763 0l-2.755 2.755-2.748 2.748-1.98 1.98a4.418 4.418 0 0 0 0 6.241 4.417 4.417 0 0 0 6.24 0l4.465-4.465 2.184-2.183-.783-.784-2.183 2.185Z"
    }
  )
);
var SvgClipOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ClipOutlined_default = SvgClipOutlined;

export { ClipOutlined_default as default };
